import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Paging } from '@triumph/design-system';
import { DataTable } from '@/app/shared/components/DataTable/DataTable';
import { DashboardTableWrapper } from '@/app/features/DebtorPortal/Dashboard/InvoicesTable/Invoices.StyledComponents';
import { TableWrapper, V2Title } from './AllInvoicesTable.StyledComponents';
import { AllInvoicesTableProps } from './AllInvoicesTable.types';
import { allInvoicesTableColumns } from './AllInvoicesTableColumns';
import { AllInvoicesTableFilters } from './AllInvoicesTableFilters';
import { AllInvoicesTableHeader } from './AllInvoicesTableHeader';

export const AllInvoicesTable: React.FC<AllInvoicesTableProps> = ({
  rows,
  totalInvoices,
  selectedInvoices,
  onSelectInvoice,
  onSelectAll,
  allSelected,
  someSelected,
  onUpdatePaymentStatus,
  paymentLinkUrl,
  currentPage,
  pageSize,
  onPageChange,
  onPageSizeChange,
  isLoading,
  handleOnSort,
  handleButtonFilterChange,
  availableFilterOptions,
  dateRangeDisplay,
}) => {
  const { t } = useTranslation('billingReminder');
  const columns = useMemo(
    () => allInvoicesTableColumns({ allSelected, someSelected, onSelectAll, selectedInvoices, onSelectInvoice }),
    [allSelected, someSelected, onSelectAll, selectedInvoices, onSelectInvoice]
  );

  return (
    <TableWrapper>
      <V2Title>{t('table.invoiceList')}</V2Title>
      <AllInvoicesTableFilters
        rows={rows}
        totalInvoices={totalInvoices}
        onButtonFilterChange={handleButtonFilterChange}
        availableFilterOptions={availableFilterOptions}
        dateRangeDisplay={dateRangeDisplay}
      />
      <DashboardTableWrapper>
        <AllInvoicesTableHeader
          selectedInvoices={selectedInvoices}
          onUpdatePaymentStatus={onUpdatePaymentStatus}
          paymentLinkUrl={paymentLinkUrl}
        />
        <DataTable
          data={rows}
          columns={columns}
          isShowOverflow={true}
          textWrapMode={2}
          alternateRowColor={true}
          maxHeight={'575px'}
          onSort={handleOnSort}
          isLoading={isLoading}
        />
      </DashboardTableWrapper>
      <Paging
        currentPage={currentPage}
        totalItems={totalInvoices}
        itemsByPage={pageSize}
        onChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        pageSizeOptions={[25, 50, 100]}
      />
    </TableWrapper>
  );
};
